import { useEffect } from 'react';

import { VideoItem } from 'services/data-manager/types';

type Params = {
    timeshiftModeOn: boolean;
    timeshiftDuration: number | undefined;
    playerProgress: number;
    livePosition: number | undefined;
    playerPaused: boolean;
    videoItem?: VideoItem;
    onPlayerPausePress(): void;
};

function useTimeshiftAutoplay({
    timeshiftModeOn,
    timeshiftDuration,
    playerProgress,
    livePosition,
    playerPaused,
    onPlayerPausePress,
}: Params) {
    useEffect(() => {
        if (
            timeshiftModeOn &&
            playerProgress &&
            playerPaused &&
            livePosition &&
            timeshiftDuration != null &&
            livePosition - playerProgress > timeshiftDuration
        ) {
            onPlayerPausePress();
        }
    }, [timeshiftModeOn, playerProgress, livePosition, playerPaused]);
}

export default useTimeshiftAutoplay;
